import type { DatasetRequestItem } from '@dmp/api/api.types';
import type { StateCreator } from 'zustand';

export type DatasetRequestState = {
  datasetRequests: DatasetRequestItem[];
  isFetchingDatasetRequests: boolean;
  datasetRequestsPage: number;
  datasetRequestsPageSize: number;
  datasetRequestsTotal: number;
  datasetRequestsSorter: {
    columnKey: string;
    order: 'asc' | 'desc' | null;
  } | null;
};

export const initialDatasetRequestState: DatasetRequestState = {
  datasetRequests: [],
  isFetchingDatasetRequests: false,
  datasetRequestsPage: 1,
  datasetRequestsPageSize: 10,
  datasetRequestsTotal: 0,
  datasetRequestsSorter: {
    columnKey: 'requested_date',
    order: 'desc',
  },
};

export const createDatasetRequestSlice: StateCreator<DatasetRequestState> = () => initialDatasetRequestState;
